import React, { useState } from 'react';
import { Button } from '../../components/ui/Button';
export function ContactFormSection() {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    state: '',
    phone: '',
    email: '',
    comments: '',
    hearAboutUs: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
  };
  return <div data-id="element-2558">
      <form onSubmit={handleSubmit} className="space-y-6" data-id="element-2559">
        <div data-id="element-2560">
          <label htmlFor="name" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-2561">
            Name *
          </label>
          <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange focus:border-transparent transition-all" data-id="element-2562" />
        </div>
        <div data-id="element-2563">
          <label htmlFor="company" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-2564">
            Company *
          </label>
          <input type="text" id="company" name="company" required value={formData.company} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange focus:border-transparent transition-all" data-id="element-2565" />
        </div>
        <div className="grid sm:grid-cols-2 gap-6" data-id="element-2566">
          <div data-id="element-2567">
            <label htmlFor="state" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-2568">
              State *
            </label>
            <input type="text" id="state" name="state" required value={formData.state} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange focus:border-transparent transition-all" data-id="element-2569" />
          </div>
          <div data-id="element-2570">
            <label htmlFor="phone" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-2571">
              Phone *
            </label>
            <input type="tel" id="phone" name="phone" required value={formData.phone} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange focus:border-transparent transition-all" data-id="element-2572" />
          </div>
        </div>
        <div data-id="element-2573">
          <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-2574">
            Email *
          </label>
          <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange focus:border-transparent transition-all" data-id="element-2575" />
        </div>
        <div data-id="element-2576">
          <label htmlFor="comments" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-2577">
            Comments
          </label>
          <textarea id="comments" name="comments" rows={4} value={formData.comments} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange focus:border-transparent transition-all resize-none" data-id="element-2578" />
        </div>
        <div data-id="element-2579">
          <label htmlFor="hearAboutUs" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-2580">
            How Did You Hear About Us?
          </label>
          <select id="hearAboutUs" name="hearAboutUs" value={formData.hearAboutUs} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange focus:border-transparent transition-all" data-id="element-2581">
            <option value="" data-id="element-2582">Pick One</option>
            <option value="advertisement" data-id="element-2583">Advertisement</option>
            <option value="competitor" data-id="element-2584">Competitor</option>
            <option value="customer-referral" data-id="element-2585">
              Existing Customer Referral
            </option>
            <option value="search-engine" data-id="element-2586">Search Engine</option>
            <option value="social-media" data-id="element-2587">Social Media</option>
            <option value="trade-show" data-id="element-2588">Trade Show</option>
            <option value="other" data-id="element-2589">Other</option>
          </select>
        </div>
        <div className="bg-gray-100 border border-gray-300 rounded-md p-4 flex items-center justify-center" data-id="element-2590">
          <span className="text-gray-500 text-sm" data-id="element-2591">reCAPTCHA Placeholder</span>
        </div>
        <Button type="submit" variant="primary" size="lg" className="w-full" data-id="element-2592">
          Submit
        </Button>
      </form>
    </div>;
}